import React from 'react';
import { handshake } from 'assets/images';

function HeroSection() {
  return (
    <div className="w-full" style={{ background: `url(${handshake})` }}>
      <div className="flex flex-col w-full h-96 items-center justify-center">
        <h1 className="text-gold text-6xl font-extrabold text-center mb-4">Our Services</h1>
        <p className="text-2xl text-white font-medium text-center">Partner With Us</p>
      </div>
    </div>
  );
}

export default HeroSection;
